import { render } from "./BoardListDataComponent.vue?vue&type=template&id=3a7d4214&scoped=true"
import script from "./BoardListDataComponent.vue?vue&type=script&lang=js"
export * from "./BoardListDataComponent.vue?vue&type=script&lang=js"

import "./BoardListDataComponent.vue?vue&type=style&index=0&id=3a7d4214&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7d4214"]])

export default __exports__